<script lang="ts" setup>
import { computed, inject } from 'vue'
import { RadioGroupOption } from '@headlessui/vue'
import type { RadioGroupProvider } from '../../types/radioGroup'
import { DTRadioGroupProvider } from '../../keys'

const props = withDefaults(defineProps<{
  text?: string
  value: any
  disabled?: boolean
}>(), { disabled: false })

const provider = inject<RadioGroupProvider>(DTRadioGroupProvider)

const radioClass = computed(() => {
  const cls = []
  if (props.disabled) {
    return [
      'bg-gray-200',
      'border-gray-200',
    ]
  }
  if (provider!.modelValue.value !== props.value) {
    cls.push(
      'bg-white border-gray-400 group-hover:border-gray-800',
    )
  }
  else {
    cls.push(
      'bg-gray-800 border-gray-800 group-hover:border-gray-800',
    )
  }
  return cls
})

const dotClass = computed(() => {
  const cls = []
  if (provider!.modelValue.value === props.value)
    cls.push('bg-white')

  else
    cls.push('bg-transparent')

  return cls
})
</script>

<template>
  <RadioGroupOption
    v-slot="{ checked }"
    class="group flex items-center justify-between px-6 py-3"
    :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
    :value="value"
    :disabled="disabled"
  >
    <slot :checked="checked as boolean">
      <span class="py-1">{{ text }}</span>
    </slot>
    <slot
      name="dot"
      :checked="checked as boolean"
    >
      <span
        class="flex size-6 shrink-0 items-center justify-center rounded-full border border-gray-200"
        :class="radioClass"
      >
        <span
          :class="dotClass"
          class="size-2 rounded-full"
        />
      </span>
    </slot>
  </RadioGroupOption>
</template>
